import { DriverInvoiceResumeOutput } from '@allocab/allocab-driver-shared-types';

import { StatCard } from '../../components/cards/StatCard';
import { t, tPlural } from '../../services/translation/translation';
import { formatDateForParisTZ } from '../../utils/date';
import { formatPrice } from '../../utils/price';

type Props = {
  data?: DriverInvoiceResumeOutput;
  isFetching: boolean;
};

export const FortnightlyInvoiceTotal = ({ isFetching, data }: Props) => {
  if (!data) {
    return null;
  }

  return (
    <div className="gap-4 grid lg:grid-cols-4 grid-cols-2 text-center">
      <StatCard
        text={formatPrice(data.totalFareIn - data.totalComOut - data.totalOnBoardSales)}
        caption={
          data.payed
            ? t('invoicing-route.payed', {
                date: formatDateForParisTZ(data.paymentDate, t('date.date-longer'), false),
              })
            : t('invoicing-route.not-payed', {
                date: formatDateForParisTZ(data.paymentDate, t('date.date-longer'), false),
              })
        }
        isFetching={isFetching}
      />
      <StatCard
        text={formatPrice(data.totalFareIn)}
        caption={
          <span className="flex flex-col">
            <span>{t('invoicing-route.total-tolls', { price: formatPrice(data.totalTolls) })}</span>
            <span>{tPlural('invoicing-route.invoice-sent', { count: data.invoiceIn.length })}</span>
          </span>
        }
        isFetching={isFetching}
      />
      <StatCard
        text={formatPrice(data.totalComOut * -1)}
        caption={tPlural('invoicing-route.invoice-received', { count: data.invoiceOut.length })}
        isFetching={isFetching}
      />
      <StatCard
        text={formatPrice(data.totalOnBoardSales)}
        caption={t('invoicing-route.onboard-sales')}
        isFetching={isFetching}
      />
    </div>
  );
};
